// deps
import { useState, useCallback } from "react";

// internal deps
import { GlobalHeaderState } from "@swiggy-private/checkout-core";
import { LocalStorage } from "@swiggy-private/core-ui";

// constants
import { DO_STORAGE_CART_KEY } from "@dineout-cart-client/constants/Constants";

// apis
import { createPaymentLinkWrapper } from "@dineout-cart-client/apis/PaymentLink";

export const usePaymentLink = () => {
    const [paymentUniqueId, setPaymentUniqueId] = useState("");
    const [isLoadingPaymentLink, setIsLoadingPaymentLink] = useState(false);
    const [error, setError] = useState(false);

    const generatePaymentLink = useCallback(async (): Promise<void> => {
        setIsLoadingPaymentLink(true);
        setError(false); // Reset error state
        try {
            const createPaymentLinkResp = await createPaymentLinkWrapper();

            if (createPaymentLinkResp.isErr()) {
                throw createPaymentLinkResp;
            }
            const paymentLink = createPaymentLinkResp.unwrap();
            GlobalHeaderState.updateHeaders({ cartkey: paymentLink as string });

            // This is needed to restore the cart key before calling GPO in webview refresh scenarios
            LocalStorage.setItem(DO_STORAGE_CART_KEY, paymentLink as string);
            setPaymentUniqueId(paymentLink);
        } catch (error) {
            setError(true);
        } finally {
            setIsLoadingPaymentLink(false);
        }
    }, []);

    return {
        generatePaymentLink,
        paymentUniqueId,
        isLoadingPaymentLink,
        error,
    };
};
